import { apiSlice } from "./apiSlice";

export const classLogApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAllClassLogs: builder.query({
			query: () => "/ClassLog",
			providesTags: (result) =>
				result
					? [
							...result.map(({ id }) => ({ type: "ClassLog", id })),
							{ type: "ClassLog", id: "LIST" },
					  ]
					: [{ type: "ClassLog", id: "LIST" }],
		}),

		getClassLogDetails: builder.query({
			query: (id) => `/ClassLog/details/${id}`,
			providesTags: (result, error, id) => [{ type: "ClassLog", id }],
		}),

		createClassLogWithAbsences: builder.mutation({
			query: (data) => ({
				url: "/ClassLog/create-with-absences",
				method: "POST",
				body: data,
			}),
			invalidatesTags: [{ type: "ClassLog", id: "LIST" }],
		}),

		updateClassLog: builder.mutation({
			query: ({ id, ...data }) => ({
				url: `/ClassLog/${id}`,
				method: "PUT",
				body: data,
			}),

			invalidatesTags: (result, error, { id }) => [
				{ type: "ClassLog", id },
				{ type: "ClassLog", id: "LIST" },
			],
		}),

		deleteClassLog: builder.mutation({
			query: (id) => ({
				url: `/ClassLog/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: [{ type: "ClassLog", id: "LIST" }],
		}),

		getStudentsByDepartment: builder.query({
			query: (departmentId) => `/Student/department/${departmentId}`,
			providesTags: (result, error, departmentId) => [
				{ type: "Students", id: departmentId },
			],
		}),

		getLogsByDepartmentAndSubject: builder.query({
			query: ({ departmentId, subjectId }) =>
				`/ClassLog/by-department-and-subject?departmentId=${departmentId}&subjectId=${subjectId}`,
			providesTags: (result) =>
				result
					? [
							...result.map(({ classLog }) => ({
								type: "ClassLog",
								id: classLog.id,
							})),
							{ type: "ClassLog", id: "LIST" },
					  ]
					: [{ type: "ClassLog", id: "LIST" }],
		}),

		getLogsByDepartmentGrouped: builder.query({
			query: (departmentId) =>
				`/ClassLog/by-department-grouped-by-subject?departmentId=${departmentId}`,
			providesTags: [{ type: "ClassLog", id: "LIST" }],
		}),

		getLogsByTeacherGrouped: builder.query({
			query: (teacherId) =>
				`/ClassLog/by-teacher-grouped?teacherId=${teacherId}`,
			providesTags: [{ type: "ClassLog", id: "LIST" }],
		}),
	}),
});

export const {
	useGetAllClassLogsQuery,
	useGetClassLogDetailsQuery,
	useCreateClassLogWithAbsencesMutation,
	useUpdateClassLogMutation,
	useDeleteClassLogMutation,
	useGetStudentsByDepartmentQuery,
	useGetLogsByDepartmentAndSubjectQuery,
	useGetLogsByDepartmentGroupedQuery,
	useGetLogsByTeacherGroupedQuery,
} = classLogApiSlice;
